import { render } from "./VariableManagerModal.vue?vue&type=template&id=0082b74d&ts=true"
import script from "./VariableManagerModal.vue?vue&type=script&lang=ts"
export * from "./VariableManagerModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__